import makeStyles from "@material-ui/core/styles/makeStyles";

export default makeStyles((theme) => ({
  marketTable: {
    "& .MuiTableContainer-root": {
      overflow: "revert !important",
    },
    "& .MuiTableCell-root": {
      fontSize: [theme.fontSize["12"], "!important"],
      padding: [theme.spacing(5), "!important"],
    },
    "& .MuiTableCell-head": {
      fontSize: [theme.fontSize["10"], "!important"],
      padding: [theme.spacing(1), "!important"],
    },
    "& .MuiTable-root": {
      // display: "table-row !important",
      borderSpacing: "0px !important",
    },
    "& .MuiTableHead-root": {
      "& th": {
        top: "0px !important",
      },
    },
  },
  recentMarketContainer: {
    "& .MuiTable-root": {
      overflow: "hidden !important",
      display: "table !important",
    },
  },
  tableContainer: {
    overflowY: "scroll",
    height: (props) => props.height || [theme.spacing(100), "!important"],
    position: "relative",
  },
  appBar: {
    padding: 0,
    borderBottom: `0.2px solid ${theme.palette.secondary.tint15}`,
    backgroundColor: "inherit",
    "& .MuiTab-wrapper": {
      fontSize: "60%",
      fontWeight: "bold",
    },
    "& button": {
      minWidth: [theme.spacing(45), "!important"],
    },
  },
  extraTextContainer: {
    display: "flex",
    height: "50%",
    alignItems: "center",
    width: "100%",
    justifyContent: "space-around",
    paddingRight: theme.spacing(10),
  },
  switchBtn: {
    height: theme.spacing(8),
    "& .MuiToggleButton-root": {
      color: theme.palette.secondary.tint60,
      fontSize: theme.fontSize["12"],
      backgroundColor: theme.palette.background.main,
      "&:hover": {
        filter: "brightness(95%)",
      },
    },
    "& .MuiToggleButton-root.Mui-selected": {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.white.main,
      "&:hover": {
        filter: "brightness(120%)",
      },
    },
  },
  iconX: {
    fontSize: "100% !important",
  },
}));
